// EventStatus itself now lives with the rule engine — form-helpers' isReadOnly
// depends on it, and the engine is being extracted into a standalone package
// that cannot import out of the app. Re-exported here so every existing
// `~/components/Events/event-status` import keeps working unchanged.
import { EventStatus } from "@viedoc/me-core/form";

export { EventStatus };

// These stay app-side: event-list presentation predicates, not engine logic.
// Nothing in the engine uses them.
export const isPastEvent = (event) =>
    event.status === EventStatus.MISSING ||
    event.status === EventStatus.RECEIVED;

export const isUpcomingEvent = (event) =>
    event.status === EventStatus.ACTIVE ||
    event.status === EventStatus.SCHEDULED;
